"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _focus = require("@react-aria/focus");

var _iconCloseModal = _interopRequireDefault(require("../../icons/icon-close-modal.svg"));

var _isEnterOrSpace = _interopRequireDefault(require("../../helpers/isEnterOrSpace"));

var _isJSX = _interopRequireDefault(require("../../helpers/isJSX"));

var _CustomReactMarkdown = _interopRequireDefault(require("../MarkdownRenderers/CustomReactMarkdown"));

var _classNameHelper = require("../../helpers/classNameHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InfoModal = function InfoModal(props) {
  var children = props.children,
      headerIcon = props.headerIcon,
      hideIcon = props.hideIcon,
      isOpen = props.isOpen,
      onRequestClose = props.onRequestClose,
      styleFlag = props.styleFlag,
      buttonElement = props.buttonElement,
      contentLabel = props.contentLabel,
      openTrack = props.openTrack,
      contentLinkTrack = props.contentLinkTrack;
  var style = (0, _classNameHelper.styler)(styleFlag);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      modalIsOpen = _useState2[0],
      setModalIsOpen = _useState2[1];

  var appElement = document.body.querySelector('.se-page');
  var ButtonElement = buttonElement;
  var modalProps = {
    ariaHideApp: !!appElement,
    appElement: appElement
  };
  (0, _react.useEffect)(function () {
    if (isOpen !== null && modalIsOpen !== isOpen) {
      setModalIsOpen(isOpen);
    }
  }, [isOpen]);

  var openModal = function openModal(event) {
    event.stopPropagation();
    event.preventDefault();
    var disabled = props.disabled;

    if (disabled) {
      return;
    }

    if (openTrack) {
      openTrack();
    }

    setModalIsOpen(true);
  };

  var closeModal = function closeModal(event) {
    event.stopPropagation();
    event.preventDefault();
    setModalIsOpen(false);
  };

  var renderHeader = function renderHeader() {
    var header = props.header,
        subheader = props.subheader;

    if (!header) {
      return null;
    }

    return (0, _isJSX["default"])(header) ? header : /*#__PURE__*/_react["default"].createElement("h1", null, subheader && /*#__PURE__*/_react["default"].createElement("span", {
      className: "info-modal__subheading"
    }, subheader), header);
  };

  var renderMessage = function renderMessage() {
    var message = props.message;

    if (!message) {
      return null;
    }

    if ((0, _isJSX["default"])(message)) {
      return message;
    }

    var linkActions = {};

    if (contentLinkTrack instanceof Function) {
      linkActions['*'] = contentLinkTrack;
    }

    return /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
      linkActions: linkActions,
      linkMeta: ['allowIcon', 'openNewTab'],
      source: message
    });
  };

  var closeHandler = onRequestClose || closeModal;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children && /*#__PURE__*/_react["default"].createElement(_focus.FocusRing, {
    focusRingClass: style('info-modal__trigger-focused')
  }, /*#__PURE__*/_react["default"].createElement(ButtonElement, {
    role: "button",
    tabIndex: "0",
    className: style('info-modal__trigger'),
    onClick: openModal,
    onKeyPress: function onKeyPress(event) {
      return (0, _isEnterOrSpace["default"])(event) && openModal(event);
    }
  }, children)), /*#__PURE__*/_react["default"].createElement(_reactModal["default"], _extends({
    className: style('info-modal'),
    isOpen: modalIsOpen,
    onRequestClose: closeHandler,
    contentLabel: contentLabel,
    overlayClassName: "info-modal__overlay"
  }, modalProps), /*#__PURE__*/_react["default"].createElement("header", {
    className: style('info-modal__header')
  }, /*#__PURE__*/_react["default"].createElement(_focus.FocusRing, {
    focusRingClass: style('info-modal__close-focused')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    "aria-label": "Close",
    tabIndex: "0",
    className: "info-modal__close",
    onClick: closeHandler,
    onKeyPress: function onKeyPress(event) {
      return (0, _isEnterOrSpace["default"])(event) && closeHandler(event);
    }
  }, /*#__PURE__*/_react["default"].createElement(_iconCloseModal["default"], {
    className: "info-modal__close--icon"
  }))), !hideIcon && headerIcon && /*#__PURE__*/_react["default"].createElement("span", {
    className: style('info-modal__info-icon')
  }, headerIcon), renderHeader()), /*#__PURE__*/_react["default"].createElement("main", {
    className: style('info-modal__main')
  }, renderMessage())));
};

InfoModal.propTypes = {
  children: function children(props, propName) {
    var prop = props[propName],
        isOpen = props.isOpen,
        onRequestClose = props.onRequestClose;

    if (prop && (isOpen !== null || onRequestClose !== null)) {
      return new Error("[".concat(propName, "] cannot be used in conjunction with external state handlers [isOpen] and [onRequestClose]"));
    }

    return null;
  },
  header: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  subheader: _propTypes["default"].string,
  headerIcon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  styleFlag: _propTypes["default"].string.isRequired,
  hideIcon: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool,
  onRequestClose: _propTypes["default"].func,
  buttonElement: _propTypes["default"].string,
  contentLabel: _propTypes["default"].string.isRequired,
  openTrack: _propTypes["default"].func,
  contentLinkTrack: _propTypes["default"].func
};
InfoModal.defaultProps = {
  children: null,
  header: null,
  subheader: null,
  headerIcon: null,
  message: '',
  hideIcon: false,
  disabled: false,
  isOpen: null,
  onRequestClose: null,
  buttonElement: 'div',
  openTrack: null,
  contentLinkTrack: null
};
var _default = InfoModal;
exports["default"] = _default;